export const bringQualifiedLead = {
  '@context': 'https://schema.org',
  '@type': 'ProgramMembership',
  name: 'Bring a Qualified Lead Program',
  url: 'https://www.boldare.com/bring-a-qualified-lead/',
  description:
    'Earn a €2200 reward for referring a qualified lead to Boldare. This program is designed for digital product creators and consultants who understand the challenges of product development and help solve them by connecting with the right partners.',
  hostingOrganization: {
    '@type': 'Organization',
    name: 'Boldare',
    url: 'https://www.boldare.com',
  },
};
